import axios from 'axios';

// Fonction pour récupérer le cookie
const getCookie = (name) => {
    const nameEQ = name + "=";
    const ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) === ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
};

// Créez une instance Axios
const axiosUserInstance = axios.create({
    baseURL: process.env.REACT_APP_API_URL,
});

// Intercepteur de requête pour ajouter le token Bearer
axiosUserInstance.interceptors.request.use(
    config => {
        // Récupérer le token depuis les cookies
        const token = getCookie("user_apiToken"); // Remplacez par le nom de votre cookie

        // Si le token existe, on l'ajoute à l'en-tête Authorization
        if (token) {
            config.headers["Authorization"] = `Bearer ${token}`;
        }

        return config;
    },
    error => {
        return Promise.reject(error);
    }
);

// Configurez un intercepteur de réponse
axiosUserInstance.interceptors.response.use(
    response => response,
    async (error) => {
        // Vérifiez si l'erreur est une erreur 401
        if (error.response && error.response.status === 401) {
            // Vérifiez le contenu du message d'erreur
            const errorMessage = error.response.data?.message;
            if (errorMessage === "Unauthenticated.") {
                handleUnauthorized();
            }
        }
        return Promise.reject(error);
    }
);

// Fonction pour gérer les redirections
const handleUnauthorized = () => {
    const cookies = document.cookie.split(";"); // Récupère tous les cookies
    for (let cookie of cookies) {
        const cookieName = cookie.split("=")[0].trim(); // Récupère le nom du cookie
        // Supprime le cookie en définissant sa date d'expiration dans le passé
        document.cookie = `${cookieName}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; SameSite=None; Secure`;
    }

    // Redirection ici
    window.location.href = '/'; // Changez ceci selon votre route de connexion
};

export default axiosUserInstance;
